import { validLanguages } from './constants.js';

/**
 * Extracts language subtag from a BCP47 language string.
 * @param languageTag `string` language tag
 * @returns language subtag
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/lang#language_tag_syntax
 */
const getLanguageSubtag = (languageTag) => languageTag.split('-')[0];
/**
 * Determines the language that is used in the translations. This is either:
 * 1. The language given as a parameter, if there are translations for it.
 * 2. The fallback language aka the first valid translation language.
 *
 * @param maybeLang `string` wanted translation language
 * @returns determined translation language
 */
const getValidLangOrFallback = (maybeLang) => {
    const index = typeof maybeLang === 'string'
        ? Math.max(0, // Fallback to the first valid entry, if language is invalid
        validLanguages.indexOf(maybeLang))
        : 0;
    return validLanguages[index];
};
/**
 * This function provides simple interpolation support. Instances of `{#}`
 * are replaced with parameter values.
 *
 * @param string `string` interpolated string
 * @param replacements `(string | number)[]` repleacement values
 * @returns interpolated string
 */
const sprintf = (string, ...replacements) => {
    const replacement = replacements.shift();
    return replacement
        ? sprintf(string.replace('{#}', String(replacement)), ...replacements)
        : string;
};

export { getLanguageSubtag, getValidLangOrFallback, sprintf };
//# sourceMappingURL=utils.js.map
